var _mask, _path, _path2, _rect, _mask2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlwaysyourchoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_105_1695",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 48V41.5H21.5L15 48Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 41.5H11V37.5H15V41.5ZM15 48L17.8284 50.8284L11 57.6569V48H15ZM21.5 41.5V37.5H31.1569L24.3284 44.3284L21.5 41.5ZM19 41.5V48H11V41.5H19ZM12.1716 45.1716L18.6716 38.6716L24.3284 44.3284L17.8284 50.8284L12.1716 45.1716ZM21.5 45.5H15V37.5H21.5V45.5Z",
    fill: "black",
    mask: "url(#path-1-inside-1_105_1695)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 25H14C12.8954 25 12 25.8954 12 27V41C12 42.1046 12.8954 43 14 43H35C36.1046 43 37 42.1046 37 41V32H23C21.8954 32 21 31.1046 21 30V25Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 25,
    height: 18,
    rx: 2,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_105_1695",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 35V28.5H38.5L45 35Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28.5H49V24.5H45V28.5ZM45 35L42.1716 37.8284L49 44.6569V35H45ZM38.5 28.5V24.5H28.8431L35.6716 31.3284L38.5 28.5ZM41 28.5V35H49V28.5H41ZM47.8284 32.1716L41.3284 25.6716L35.6716 31.3284L42.1716 37.8284L47.8284 32.1716ZM38.5 32.5H45V24.5H38.5V32.5Z",
    fill: "black",
    mask: "url(#path-5-inside-2_105_1695)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlwaysyourchoice);
export default __webpack_public_path__ + "static/media/Always your choice.d91a4bc2fd880bcd9e1176da0e7fee62.svg";
export { ForwardRef as ReactComponent };